module.exports = __webpack_public_path__ + "img/marker_qr.437fbbab.png";